import { Component, OnInit } from '@angular/core';

import uniqBy from 'lodash.uniqby';

import { ShaftSealProduct } from '../../models/shaft-seal-product.interface';
import { ShaftSealButton } from '../../models/shaft-seal-button.interface';
import { ShaftSealProductOptions } from '../../models/shaft-seal-product-options.interface';
import { ShaftSealProductQuery } from '../../models/shaft-seal-product-query.interface';

import { ShaftSealProductSelectorService } from '../../shaft-seal-product-selector.service';


@Component({
  selector: 'shaft-seal-product-selector',
  styles: [`
    .form-margin {
      margin-top: 25px;
    }
  `],
  template: `
    <div class="well well-lg">
      <shaft-seal-product-form
        [form_query]="form_query"
        [shaft_diameter_options]="shaft_diameter_options"
        [stern_tube_diameter_options]="stern_tube_diameter_options"
        (update)="onUpdateFormQuery($event)">
      </shaft-seal-product-form>

      <div *ngIf='!!filtered_products' class='row'>
        <div class="col-sm-6 col-md-6 col-lg-3 form-margin"
          *ngFor='let item of filtered_products'>
          <shaft-seal-button [product]="item" *ngIf="item.part_number !== ''">
          </shaft-seal-button>
        </div>
      </div>
    </div>
  `
})

export class ShaftSealProductSelectorComponent implements OnInit {

  products: ShaftSealProduct[];
  shaft_diameter_options: ShaftSealProductOptions[];
  stern_tube_diameter_options: ShaftSealProductOptions[];
  filtered_products: ShaftSealButton[];
  form_query: ShaftSealProductQuery;

  constructor(private productService: ShaftSealProductSelectorService) {}

  ngOnInit() {}

  onUpdateFormQuery(event: ShaftSealProductQuery) {
    this.productService.
      getShaftSealProducts(event)
      .subscribe((data: ShaftSealProduct[]) => {
        this.products = data;
        this.form_query = event;

        let temp_shaft_diameter_options = this.products.map( function(obj){
          return { key: obj.shaft_diameter_per_mill, value: obj.shaft_diameter };
        });
        this.shaft_diameter_options = uniqBy(temp_shaft_diameter_options, 'key');

        let temp_stern_tube_diameter_options = this.products.map( function(obj){
          return { key: obj.stern_tube_diameter_per_mill, value: obj.stern_tube_diameter };
        });
        this.stern_tube_diameter_options = uniqBy(temp_stern_tube_diameter_options, 'key');

        if ( event.shaft_diameter_metric !== null &&
             event.shaft_diameter !== null &&
             event.stern_tube_diameter !== null &&
             !!this.products ) {
          this.filtered_products = [
            { 'part_number' : this.products[0].shaft_seal_part_number,
              'product_url' : this.products[0].product_url,
              'label' : 'PSS Shaft Seal Part #:'
            }, {
              'part_number' : this.products[0].maintenance_kit_part_number,
              'product_url' : this.products[0].maintenance_kit_url,
              'label' : 'PSS Maintenance Kit Part #:'
            }, {
              'part_number' : this.products[0].shaft_seal_pro_part_number,
              'product_url' : this.products[0].pro_product_url,
              'label' : 'PSS PRO Shaft Seal Part #:'
            }, {
              'part_number' : this.products[0].pro_maintenance_kit_part_number,
              'product_url' : this.products[0].pro_maintenance_kit_url,
              'label' : 'PSS PRO Maintenance Kit Part #:'
            }
          ];
        } else if ( event.shaft_diameter_metric === null &&
                    event.shaft_diameter === null &&
                    event.stern_tube_diameter === null ) {
          this.shaft_diameter_options = [];
          this.stern_tube_diameter_options = [];
          this.filtered_products = [];
          this.products = [];
        } else {
          this.filtered_products = [];
        }

        return;
      });
  }
}


// WEBPACK FOOTER //
// ./app/javascript/product_search/app/shaft-seal-product-selector/containers/shaft-seal-product-selector/shaft-seal-product-selector.component.ts